export const RESCHEDULE: string = 'I would like to reschedule my Curb-it job to '



// WEBPACK FOOTER //
// ./src/constants/reschedule.ts